import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import MobileHeader1 from "@/_LayoutsRelated/mobileHeaders/mobileHeader1/MobileHeader1";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { deleteDocuments as _deleteDocuments, deleteFileObject as _deleteFileObject, filterFieldsWithFiles, handleFileChange } from "../../utls";
import StepBody from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepBody/StepBody";
import StepDescription from "@/pages/tracking/components/SharedComponents/StepDetailsComponent_TS/StepDescription/StepDescription";
import stl from "./TrackingFinanceStepDetails.module.css";
import useApi from "@hooks/useApi";
import { api__getTrackingStepDetails } from "@/apis/orderTracking/api__getOrderTracking";
import useHelpers from "@hooks/useHelpers";
import useButtonLoading from "@hooks/useButtonLoading";
var TrackingFinanceStepDetails = function TrackingFinanceStepDetails() {
  var _details$step_desc;
  var params = useParams();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  //-------------------------------------------------------------------
  var orderId = params.orderId,
    stepNum = params.stepNum;
  var buttonLoading = useButtonLoading();
  var _useApi = useApi([orderId], function () {
      return api__getTrackingStepDetails({
        orderId: orderId,
        stepNum: stepNum,
        isFinance: true
      });
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    details = _useApi2[2];

  //-------------------------------------------------------------------
  var _useState = useState({}),
    fileObjects = _useState[0],
    setFileObjects = _useState[1];
  var _useState2 = useState({}),
    preSignData = _useState2[0],
    setPreSignData = _useState2[1];
  var _useState3 = useState([]),
    uploadDocumentsData = _useState3[0],
    setUploadDocumentsData = _useState3[1];
  //-------------------------------------------------------------------
  useEffect(function () {
    var fieldsWithFiles = filterFieldsWithFiles(details);
    setUploadDocumentsData(fieldsWithFiles);
  }, [details]);
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  if (error) {
    navigateTo("/page404", {
      ref: "order-not-found"
    });
  }
  return /*#__PURE__*/React.createElement(Layout, {
    headHideLinks: true,
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    loading: true,
    hideHeaderOnmobile: true,
    custommobileHeader: /*#__PURE__*/React.createElement(MobileHeader1, {
      title: details === null || details === void 0 ? void 0 : (_details$step_desc = details.step_desc) === null || _details$step_desc === void 0 ? void 0 : _details$step_desc.title,
      buttonFunction: function buttonFunction() {
        navigateTo("/tracking-finance-details/".concat(orderId));
      }
    })
  }, Object.keys(details).length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.trackingStepContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.trackingStepCardContainer
  }, /*#__PURE__*/React.createElement(StepDescription, {
    isFinance: true,
    details: details,
    stepNum: stepNum
  }), /*#__PURE__*/React.createElement(StepBody, {
    isFinance: true,
    details: details,
    orderId: orderId,
    preSignData: preSignData,
    fileObjects: fileObjects,
    uploadDocumentsData: uploadDocumentsData,
    buttonLoading: buttonLoading,
    stepNum: stepNum,
    onFileChange: function onFileChange(file, field) {
      return handleFileChange(file, field, setFileObjects, setPreSignData, setUploadDocumentsData);
    },
    deleteFileObject: function deleteFileObject(field) {
      return _deleteFileObject(field, setFileObjects);
    },
    setFileObjects: setFileObjects,
    deleteDocuments: function deleteDocuments(field) {
      return _deleteDocuments(field, setUploadDocumentsData);
    }
  }))) : null);
};
export default TrackingFinanceStepDetails;